export default "__VITE_ASSET__DOAps_rp__"